export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14558.5ab65267.jpg";